import "./Background.scss";

import { FCC } from "types";

export const Background: FCC = ({ children }) => (
  <div className="pattern-background flex min-h-screen flex-col bg-primary-100">
    {children}
  </div>
);
